import type { AgreementDocument as Document } from "../lib/api";

/** Readers display captured plain text, without evaluating HTML, Markdown or
 * field expressions. Document identity is independent of signature timestamps. */
export function AgreementDocument({ document }: { document: Document }) {
  return <section role="region" aria-label="Agreement document" tabIndex={0} className="my-4 min-w-0 rounded-xl border border-line bg-white p-4 text-navy [overflow-wrap:anywhere] focus-visible:outline focus-visible:outline-2 focus-visible:outline-brand-red sm:p-5">
    <h3 className="text-lg font-bold">{document.title}</h3>
    {document.details?.map((detail, index) => <p key={index} className="mt-2 text-sm text-mut">{detail.label}: {detail.value}</p>)}
    {document.sections.map((section, index) => <section key={index} className="mt-5">
      {section.heading && <h4 className="font-semibold">{section.heading}</h4>}
      <p className="mt-2 whitespace-pre-wrap text-sm leading-6">{section.body}</p>
    </section>)}
    <details className="mt-5 text-xs text-mut"><summary className="min-h-8 cursor-pointer font-medium">Document reference</summary>
      <p className="mt-2">{document.id}</p><p className="mt-1">Template {document.templateRevision} · saved {new Date(document.templateSavedAt).toLocaleString()}</p>
    </details>
  </section>;
}
